import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "arrow-share-right, next, forward" }, [
      _createElementVNode("path", {
        id: "vector",
        d: "M18.75 9.99984L10.4167 2.9165V7.08317C3.33333 7.08317 1.25 9.99984 1.25 17.0832C2.5 14.5832 3.33333 12.9165 10.4167 12.9165V17.0832L18.75 9.99984Z",
        stroke: "currentColor"
      })
    ], -1)
  ])))
}
export default { render: render }